import { AxiosInstance } from "axios";
import Logger from "@/helpers/logger";
import NullLogger from "@/helpers/null-logger";
import ClientLike from "./client-like";

/**
 * 今回のAPIに合わせたクライアント
 * @description
 * {
 *   status: 0が正常、1がエラー,
 *   data: データ本体（異常時はnull）
 *   message: エラーメッセージのリスト（正常時はnull）
 * }
 */
export default class Client implements ClientLike {
  public constructor(private readonly axios: AxiosInstance) {}

  public logger: Logger = new NullLogger();

  public async get(url: string, params: object = {}): Promise<any> {
    const res = await this.axios.get(url, { params });
    this.logger.log(url, res.status, res.data);
    if (res.data.status) {
      throw res.data.message;
    }
    return res.data.data;
  }

  public async post(url: string, data: any, params: object = {}): Promise<any> {
    const res = await this.axios.post(url, data, { params });
    this.logger.log(url, res.status, res.data);
    if (res.data.status) {
      throw res.data.message;
    }
    return res.data.data;
  }
}
